<div *ngIf="isAdminObservable | async as isAdmin" class="card">
	<div class="card-body">

		<al-tabs [tabInfo]="tabInfos" [selectedTab$]="selectedTabId$"></al-tabs>

		<div class="tabs-container">
			<div style="padding: 20px 10px 10px 10px;" [ngSwitch]="selectedTabIdBasedOnRoute$ | async">
				<app-shell-admin-company-management-grid *ngSwitchCase="'company-management'"></app-shell-admin-company-management-grid>
				<app-shell-admin-user-company-management-grid *ngSwitchCase="'user-company-management'"></app-shell-admin-user-company-management-grid>
				<app-shell-admin-users-management-grid *ngSwitchCase="'user-management'"></app-shell-admin-users-management-grid>
				<app-shell-admin-company-request-management-grid *ngSwitchCase="'company-request-management'"></app-shell-admin-company-request-management-grid>
				<app-shell-admin-company-access-request-management-grid *ngSwitchCase="'company-access-request-management'"></app-shell-admin-company-access-request-management-grid>
				<al-applications *ngSwitchCase="'applications'"></al-applications>
				<app-shell-application-logs-overview *ngSwitchCase="'application-logs'"></app-shell-application-logs-overview>
				<!--<app-shell-link-transfer-tool *ngSwitchCase="'link-transfer'"></app-shell-link-transfer-tool>-->
			</div>
		</div>
	</div>
</div>
